import { Injectable, ViewContainerRef, inject } from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ConfirmDialog2Component } from './confirm-dialog/confirm-dialog2.component';

@Injectable()
export class ConfirmService {
  private dialog = inject(MatDialog);



  // Note, when using pipe(),
  // Need take(1) instead of first due to EmptyError (when hit cancel)

  public confirm(
    title: string, message: string, viewContainerRef: ViewContainerRef, defaultCancel: boolean = false, okText = 'OK', cancelText = 'Cancel'
  ): Observable<boolean> {
    const config = new MatDialogConfig();
    config.viewContainerRef = viewContainerRef;

    const dialogRef: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, config);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.defaultCancel = defaultCancel;
    dialogRef.componentInstance.okText = okText;
    dialogRef.componentInstance.cancelText = cancelText;

    return dialogRef.afterClosed();
  }

  public confirm2(title: string, message: string, confirmText = 'OK', cancelText = 'Cancel', noCancel = false, icon = '', iconColor = '', align = 'start'): Observable<boolean> {
    const dialogRef: MatDialogRef<ConfirmDialog2Component>  = this.dialog.open(ConfirmDialog2Component, {
      data: { title, message, confirmText, cancelText, noCancel, icon, iconColor, align },
    });

    return dialogRef.afterClosed();
  }
}
